import React from 'react'
import { useEffect, useState, useMedia } from 'sb-hooks'
import { constants } from 'common/helpers'
import actions from 'redux/actions'
import request from 'sb-request'

import Mobile from './Mobile/Mobile'
import ExceptMobile from './ExceptMobile/ExceptMobile'


const close = () => actions.models.modals.close(constants.modals.SkincareProductDetails)

const fetchProduct = (slug) =>
  request.get(`rest/product?slug=${slug}&detailed=true`)

const useProduct = (id) => {
  const [ { isFetching, product }, setState ] = useState({ isFetching: true, product: {} })

  const setIsFetching = (isFetching) => setState((state) => ({
    ...state,
    isFetching,
  }))

  useEffect(() => {
    setIsFetching(true)

    fetchProduct(id)
      .then((data) => setState({
        product: data,
        isFetching: false,
      }))
      .catch(() => close())
      .finally(() => setIsFetching(false))
  }, [ id ])

  return {
    product,
    isFetching,
  }
}


const SkincareProductDetailsModal = (props) => {
  const { data: { productId, onAllProductsButtonClick, onTryButtonClick, withAddToQueueButton, isAllProductsButtonVisible } } = props
  const { product, isFetching } = useProduct(productId)
  const { isMobile } = useMedia()

  const modalProps = {
    ...product,
    isFetching,
    close,
    onAllProductsButtonClick: () => {
      if (typeof onAllProductsButtonClick === 'function') {
        onAllProductsButtonClick()
      }

      close()
    },
    onTryButtonClick: () => {
      if (typeof onTryButtonClick === 'function') {
        onTryButtonClick()
      }

      close()
    },
    withAddToQueueButton,
    isAllProductsButtonVisible,
  }

  return React.createElement(isMobile ? Mobile : ExceptMobile, modalProps)
}


export default SkincareProductDetailsModal
